import { baseApi } from "../baseApi";

export const costcenterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCostCenterList: builder.query({
      query: (params) => ({
        url: `/api/resource/Cost Center`,
        params
      }),
    }),
  }),
});

export const { useGetCostCenterListQuery } = costcenterApi;
